<template>
  <div class="overlay" v-if="active">
    <div class="modal">
      <div class="layout">
        <div class="item">
          <a
            href="#"
            class="btn navigation-icon close"
            v-on:click.prevent="$emit('update:active', false)"
          ></a>

          <div class="wrapper text-center">
            <div class="d-none d-md-block">
              <h3>{{ content.headline }}</h3>
              <p>{{ content.description }}</p>
            </div>

            <div class="products mt-md-5">
              <div class="entry" v-for="item in content.product">
                <div>
                  <h5>{{ item.type }}</h5>
                  <p>{{ item.name }}</p>
                  <a
                    v-bind:href="item.cta.href"
                    v-bind:target="item.cta.target"
                    class="btn cta-plain text-red icon right-arrow d-md-none"
                    >{{ item.cta.text }}</a
                  >
                </div>

                <figure v-if="item.image">
                  <img v-bind:src="item.image.sizes.large" alt="" />
                </figure>

                <a
                  v-bind:href="item.cta.href"
                  v-bind:target="item.cta.target"
                  class="
                    btn
                    cta-pill
                    filled-red
                    icon
                    right-arrow
                    d-none d-md-inline-block
                  "
                  >{{ item.cta.text }}</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="backdrop"><!-- backdrop --></div>
  </div>
</template>

<script>
export default {
  name: "overlay",
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    content: {
      type: Object,
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";
@import "../../css/components/modal";

.overlay {
  .layout {
    position: relative;
    margin: 12rem auto;
    width: 960px;
    max-width: 90vw;
    box-shadow: 0 2rem 3rem 0 rgba(0, 0, 0, 0.75);

    .item {
      background-color: $cc-resmed-white;
      min-height: 70vh;

      h3 {
        margin-bottom: 0.75rem;
      }

      @media (min-width: 768px) {
        min-height: 580px;

        p {
          max-width: 70%;
          margin: 0 auto;
        }
      }

      .wrapper {
        padding: 3rem;
      }

      .products {
        display: flex;
        justify-content: center;
        flex-direction: column;

        h5 {
          position: relative;
          margin-bottom: 0.5rem;

          @extend %eyebrow-left;

          @media (min-width: 768px) {
            &:before {
              left: 50%;
              transform: translateX(-50%);
            }
          }
        }

        .entry {
          padding: 0 3rem;
          flex-grow: 1;
          max-width: 288px;
          width: 100%;

          figure {
            padding: 2rem 0;

            @media (min-width: 768px) {
              height: 230px;
            }

            img {
              width: 100%;
              min-width: 100px;
              max-width: 160px;
              margin: 0 auto;
            }
          }

          @media (max-width: 767px) {
            padding: 0;

            &:not(:last-child) {
              margin-bottom: 2rem;
              padding-bottom: 2rem;
              border-bottom: 1px solid rgba($cc-resmed-grey-30, 0.5);
            }

            display: flex;
            align-items: center;

            > div {
              order: 1;
              flex-grow: 1;
              text-align: left;

              p {
                margin-bottom: 0.5rem;
              }
            }

            figure {
              width: 100px;
              padding: 0;
              margin-right: 2rem;
            }
          }
        }

        @media (min-width: 768px) {
          flex-direction: row;
        }
      }
    }
  }
}
</style>